import React from 'react';
import IconInterface from './IconInterface';

function IconUserProfileWithPurpleGradient({
    height = 24,
    width = 24,
}: IconInterface) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.7"
                y="0.7"
                width="22.6"
                height="22.6"
                rx="11.3"
                stroke="url(#paint0_linear_61_2450)"
                strokeWidth="1.4"
            />
            <path
                d="M17.9592 17.2057C17.3061 15.4681 15.8912 14.1648 14.1497 13.5132C16.0544 12.3185 16.6531 9.82063 15.4558 7.92004C14.2585 6.01946 11.8095 5.42213 9.85034 6.61679C7.89115 7.81144 7.34694 10.3093 8.54421 12.2642C8.87075 12.8073 9.30612 13.2417 9.85034 13.5675C8.10884 14.1648 6.7483 15.5224 6.04082 17.2601C5.93197 17.5316 6.04082 17.8574 6.36735 17.966C6.47619 17.966 6.53061 17.966 6.58503 17.966C6.80272 17.966 7.02041 17.8031 7.07483 17.6402C8.16326 14.925 11.2109 13.5675 13.932 14.6535C15.2925 15.1966 16.3809 16.2826 16.9252 17.6402C17.034 17.9117 17.3605 18.0746 17.6327 17.966C17.9592 17.8031 18.068 17.5316 17.9592 17.2057ZM9.03401 10.0921C9.03401 8.46307 10.3946 7.10551 12.0272 7.10551C13.6599 7.10551 15.0204 8.46307 15.0204 10.0921C15.0204 11.7212 13.6599 13.0788 12.0272 13.0788C10.3946 13.0788 9.03401 11.7755 9.03401 10.0921Z"
                fill="url(#paint1_linear_61_2450)"
                stroke="url(#paint2_linear_61_2450)"
                strokeWidth="0.25"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_61_2450"
                    x1="0"
                    y1="0"
                    x2="41.1404"
                    y2="5.83855"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3E009F" />
                    <stop offset="0.794003" stopColor="#5B0069" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_61_2450"
                    x1="6"
                    y1="6"
                    x2="26.5702"
                    y2="8.91928"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3E009F" />
                    <stop offset="0.794003" stopColor="#5B0069" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_61_2450"
                    x1="6"
                    y1="6"
                    x2="26.5702"
                    y2="8.91928"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3E009F" />
                    <stop offset="0.794003" stopColor="#5B0069" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default IconUserProfileWithPurpleGradient;
